import type { Fragment, Schema } from '@tiptap/pm/model';
import { DOMSerializer, Node as PmNode } from '@tiptap/pm/model';
import type { Editor } from '@tiptap/react';

export const getSelectionAsHTML = (editor: Editor) => {
  const {
    state: {
      doc,
      selection: { from, to, $from, $to },
    },
  } = editor;

  const schema = editor.schema;
  const fragment = $from.sameParent($to)
    ? $from.parent.cut($from.parentOffset, $to.parentOffset).toJSON()
    : doc.cut(from, to).toJSON();
  const contentNode = PmNode.fromJSON(schema, fragment);

  return getHTMLFromFragment(contentNode.content, schema);
};

function getHTMLFromFragment(fragment: Fragment, schema: Schema): string {
  const documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment);

  // Add document fragment in isolation to the rest of the document.
  const temporaryDocument = document.implementation.createHTMLDocument();
  const container = temporaryDocument.createElement('div');

  container.appendChild(documentFragment);

  // Remove all attributes from the document fragment to reduce tokens
  removeAllAttributes(container);

  return container.innerHTML;
}

function removeAllAttributes(node: Node) {
  if (node instanceof Element && node.attributes) {
    while (node.attributes.length > 0) {
      node.removeAttribute(node.attributes[0].name);
    }
  }

  for (let i = 0; i < node.childNodes.length; i++) {
    removeAllAttributes(node.childNodes[i]);
  }
}
